<div class="meta-content">
    <div>
        <h3>META TAG-ek HOZZÁADÁSA</h3>
        <p>A * - al jelölt mezők kitöltése kötelező!</p>
    </div>
    <div class="contact-form">
        <form [formGroup]="metaForm!" novalidate>
            <div class="field-container">
                <div class="field">
                    <b>Meta címe *</b>
                    <div class="data">
                        <input formControlName="ogTitle" id="name" class="form-control" type="text" required />
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <b>Meta leírása *</b>
                    <div class="data">
                        <textarea formControlName="ogDescription" id="jobTitle" class="form-control" type="text"
                            required></textarea>
                    </div>
                </div>
            </div>
        </form>
        <div class="field-container">
            <div class="field">
                <b>Meta kulcsszavak</b>
                <mat-form-field appearance="outline">
                    <mat-chip-grid #chipGrid>
                        <mat-chip *ngFor="let keyword of keywords" [removable]="true"
                            (removed)="removeKeyword(keyword)">
                            {{ keyword }}
                            <mat-icon matChipRemove>delete_forever</mat-icon>
                        </mat-chip>
                        <input placeholder="Kulcsszavak" [matChipInputFor]="chipGrid"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addKeyword($event)" />
                    </mat-chip-grid>
                    <mat-hint class="hint-text">Írja be a kulcsszót, majd nyomja meg az Enter vagy a vessző (,)
                        billentyűt</mat-hint>
                </mat-form-field>

            </div>
        </div>
    </div>
</div>